/* Add-to-cart feedback: an instant "Added ✓" confirmation on the button, a dot
   that flies from the product image to the cart icon, and a cart-icon bounce
   when the count updates. Uses the theme's pub/sub (cartError) when present;
   degrades gracefully and respects prefers-reduced-motion. */
(function () {
  function reduce() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function cartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  function flyDot(originEl) {
    var cart = cartIcon();
    if (!cart || !originEl) return;
    var o = originEl.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    if (!o.width || !c.width) return;

    var dot = document.createElement('span');
    dot.className = 'atc-fly-dot';
    dot.style.left = (o.left + o.width / 2) + 'px';
    dot.style.top = (o.top + o.height / 2) + 'px';
    document.body.appendChild(dot);

    var dx = (c.left + c.width / 2) - (o.left + o.width / 2);
    var dy = (c.top + c.height / 2) - (o.top + o.height / 2);
    // Defer the end-state to the next frame so the transition runs without a
    // synchronous layout flush (void offsetWidth) on the click path.
    requestAnimationFrame(function () {
      dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.25)';
      dot.style.opacity = '0.15';
    });
    setTimeout(function () { dot.remove(); }, 760);
  }

  function bounce() {
    var cart = cartIcon();
    if (!cart || reduce()) return;
    cart.classList.remove('atc-bounce');
    void cart.offsetWidth;
    cart.classList.add('atc-bounce');
    setTimeout(function () { cart.classList.remove('atc-bounce'); }, 650);
  }

  // Optimistic "Added ✓": flip the button to a success state the instant it's
  // clicked so the ~0.5s /cart/add round-trip feels invisible. Reverts after a
  // beat, or immediately if the add actually fails (cart error).
  var lastAddedBtn = null;
  function flashAdded(btn) {
    lastAddedBtn = btn;
    btn.classList.add('atc-added');
    if (btn._atcTimer) clearTimeout(btn._atcTimer);
    btn._atcTimer = setTimeout(function () {
      btn.classList.remove('atc-added');
      btn._atcTimer = null;
    }, 1500);
  }
  function clearAdded(btn) {
    if (!btn) return;
    if (btn._atcTimer) { clearTimeout(btn._atcTimer); btn._atcTimer = null; }
    btn.classList.remove('atc-added');
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
    subscribe(PUB_SUB_EVENTS.cartError, function () { clearAdded(lastAddedBtn); });
  }

  // 1) On add-to-cart click: flash "Added ✓" (real product-form submits only,
  //    never the multi-variant "Choose options" modal opener) + fly a dot.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form__submit, .quick-add__submit, .sticky-atc__button');
    if (!btn || btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
    // Real adds only: a submit inside <product-form>, or the mobile sticky bar button
    // (it submits the product form via form=). The multi-variant "Choose options" opener
    // (a .quick-add__submit NOT inside a product-form) just opens a modal — no feedback.
    var isSticky = btn.classList.contains('sticky-atc__button');
    if (!btn.closest('product-form') && !isSticky) return;
    flashAdded(btn);
    if (reduce()) return;
    var origin;
    if (isSticky) {
      origin = btn; // fly the dot from the visible sticky bar up to the cart
    } else {
      var scope = btn.closest('product-form') || btn.closest('.product') || btn.closest('.card-wrapper') || document;
      var img = scope.querySelector && scope.querySelector('img');
      if (!img) {
        img = document.querySelector('.product__media img, .product-media-container img, .card__media img');
      }
      origin = img || btn;
    }
    flyDot(origin);
  }, true);

  // 2) Bounce the cart icon whenever its count actually changes (real add).
  function watch() {
    var cart = cartIcon();
    if (!cart || typeof MutationObserver === 'undefined') return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;        // collapse the burst of mutations from a
      scheduled = true;             // single cart re-render into one bounce
      bounce();
      setTimeout(function () { scheduled = false; }, 650);
    }).observe(cart, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
